import { EGRAHMANTREE_URL, FLAGSHIP, SITE } from '../config/site';

function IconMail() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M4 6h16v12H4V6zm0 0l8 6 8-6" strokeLinejoin="round" />
    </svg>
  );
}

function IconPhone() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path
        d="M6 4h4l2 5-2 1a11 11 0 005 5l1-2 5 2v4a2 2 0 01-2 2C9 19 5 15 4 8a2 2 0 012-4z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconPin() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M12 21s-6-5.4-6-10a6 6 0 1112 0c0 4.6-6 10-6 10z" />
      <circle cx="12" cy="11" r="2" />
    </svg>
  );
}

function IconClock() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" strokeLinecap="round" />
    </svg>
  );
}

const ITEMS = [
  {
    icon: IconMail,
    label: 'Email',
    href: `mailto:${SITE.email}`,
    text: SITE.email,
  },
  {
    icon: IconPhone,
    label: 'Phone',
    href: `tel:${SITE.phoneTel}`,
    text: SITE.phoneDisplay,
  },
  {
    icon: IconPin,
    label: 'Location',
    text: SITE.location,
  },
  {
    icon: IconClock,
    label: 'Business hours',
    text: SITE.businessHours,
  },
];

export default function ContactDetails({ showFlagshipNote = true }) {
  return (
    <div className="contact-details">
      <h3>Reach our team</h3>
      {showFlagshipNote && (
        <p className="contact-details__intro">
          For {FLAGSHIP.name} home-service bookings, visit{' '}
          <a href={EGRAHMANTREE_URL} target="_blank" rel="noopener noreferrer">
            {FLAGSHIP.name.toLowerCase()}.com
          </a>
          . For SutraMQ, SutraACS, MGOpen NMS demos, and custom software — use the form or contact
          details below.
        </p>
      )}
      {ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <div key={item.label} className="contact-item">
            <div className="contact-item__icon">
              <Icon />
            </div>
            <div>
              <strong>{item.label}</strong>
              {item.href ? (
                <a href={item.href}>{item.text}</a>
              ) : (
                <span>{item.text}</span>
              )}
            </div>
          </div>
        );
      })}
      <a href={SITE.whatsappUrl} className="btn btn--secondary contact-details__whatsapp" target="_blank" rel="noopener noreferrer">
        Chat on WhatsApp
      </a>
    </div>
  );
}
